export default class GoogleLocationView extends Backbone.View
  events:
    "keyup #js-location"                : "clearLocations"
    "keypress #js-location"             : "preventSubmit"

  initialize: (options) ->
    @$locationInput = @$("#js-location")
    @$cityInput = @$("#js-city")
    @$stateInput = @$("#js-state")
    @$countryInput = @$("#js-country")

    @autocomplete = new google.maps.places.Autocomplete(@$locationInput.get(0))
    google.maps.event.addListener @autocomplete, "place_changed", =>
      place = @autocomplete.getPlace()
      addressComponents = place.address_components

      @$cityInput.val('')
      @$stateInput.val('')
      @$countryInput.val('')

      for addressComponent in addressComponents
        switch addressComponent.types[0]
          when 'locality'
            @$cityInput.val(addressComponent.long_name)
          when 'administrative_area_level_1'
            @$stateInput.val(addressComponent.short_name)
          when 'country'
            @$countryInput.val(addressComponent.short_name)

      location = [@$cityInput.val(), @$stateInput.val(), @$countryInput.val()]
      locationResponseString = _.compact(location).join(', ')
      @$locationInput.val(locationResponseString)

      if @$cityInput.val()
        $("#js-missing-city-warning").addClass("hidden")
      else
        $("#js-missing-city-warning").removeClass("hidden")

  clearLocations: (event) ->
    if event.keyCode is 8 or event.keyCode is 46
      @$cityInput.val('')
      @$stateInput.val('')
      @$countryInput.val('')

  preventSubmit: (event) ->
    event.preventDefault() if event.keyCode is 13



// WEBPACK FOOTER //
// ./app/javascript/backbone/shared/views/google_location_view.js.coffee